import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { Helmet } from "react-helmet";
import Header from "./Header";
import { Link } from "react-router-dom";
import "react-medium-image-zoom/dist/styles.css";
import { getProAll, saveProAll, saveSeries, getSeries } from "../db"; // Import IndexedDB functions

function AllProducts() {
  const dealer_id = localStorage.getItem("dealer_id");
  const server_url = localStorage.getItem("server_url");
  const [searchTerm, setSearchTerm] = useState("");
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [series, setSeries] = useState([]);
  const [refreshBanner, setRefreshBanner] = useState(false);
  const [selectedSeries, setSelectedSeries] = useState(null);

  // Fetch Banner Data
  const getProducts = useCallback(async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      formData.append("dealer_id", dealer_id);
      const res = await axios.post(`${server_url}products.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (res.data.status === "1") {
        saveProAll(res.data.result.dealer_portfolio);
        setData(res.data.result);
        setFilteredData(res.data.result);
      } else {
        saveProAll([]);
        setData([]);
        setFilteredData([]);
        // toast.warning(res.data.error);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  }, [dealer_id, server_url]);

  const getSerices = async () => {
    try {
      const formData = new FormData();
      formData.append("company_id", "2");
      const res = await axios.post(`${server_url}series_list.php`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (res.data.status === "1") {
        setSeries(res.data.result);
        saveSeries(res.data.result); // ✅ save in local db
      } else {
        setSeries([]);
        saveSeries([]); // ✅ save in local db
        toast.warning([]);
      }
    } catch (e) {
      toast("Please Try After Some Time.");
    }
  };
  useEffect(() => {
    async function loadCachedData() {
      const cachedData = await getProAll();
      if (cachedData) setData(cachedData);

      const cachedSeries = await getSeries();
      if (cachedSeries) setSeries(cachedSeries);
    }
    loadCachedData();
    getProducts();
    getSerices();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getProducts]);

  useEffect(() => {
    if (refreshBanner) {
      getProducts();
      setRefreshBanner(false);
    }
  }, [refreshBanner, getProducts]);

  useEffect(() => {
    if (searchTerm === "") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) =>
        item.product_name.toLowerCase().includes(searchTerm.toLowerCase()),
      );
      setFilteredData(filtered);
    }
  }, [searchTerm, data]);

  useEffect(() => {
    let filtered = data;
    if (selectedSeries !== null) {
      filtered = filtered.filter(
        (product) => product.product_series_id === selectedSeries,
      );
    }
    if (searchTerm) {
      filtered = filtered.filter((product) =>
        product.product_name.toLowerCase().includes(searchTerm.toLowerCase()),
      );
    }
    setFilteredData(filtered);
  }, [selectedSeries, searchTerm, data]);
  return (
    <>
      <Helmet>
        <title>Manufacturer Catalog - AG Home Decor</title>
        <meta
          name="description"
          content="Full catalog of decorative poster tiles, border tiles, and custom designs available for manufacturing. Everything is possible."
        />
        <meta
          name="keywords"
          content="tile catalog, manufacturer stock, decorative tiles inventory, AG Home Decor"
        />
      </Helmet>
      <div
        className="page-content header-clear-small"
        style={{ padding: "0px 10px" }}
      >
        <Header />
        <div className="search-page">
          <div
            className="header fixed left-0 w-full bg-white z-50"
            style={{ top: "68px", height: "auto", padding: "5px" }}
          >
            <div
              className="search-box search-header bg-theme card-style me-3 ms-3"
              style={{ margin: "0px 0px 0px 0px" }}
            >
              <i className="fa fa-search"></i>
              <input
                type="text"
                className="border-0"
                placeholder="What are you looking for?"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <Link
                className="clear-search mt-0"
                onClick={() => setSearchTerm("")}
              >
                <i className="fa fa-times color-red-dark"></i>
              </Link>
            </div>
          </div>

          {/* <div
            className="header fixed left-0 w-full bg-white z-50  p-1"
            style={{
              height: "auto",
              marginTop: "130px",
              whiteSpace: "nowrap",
              overflowX: "auto", // Allows horizontal scrolling
            }}
          >
            <button
              style={{
                display: "inline-flex",
                margin: "0px 5px 0px",
                padding: "5px 10px",
                whiteSpace: "nowrap",
              }}
              className={`series-item ${
                selectedSeries !== null
                  ? "active btn btn-full rounded-0 text-uppercase font-400 border-red-dark color-red-dark bg-theme"
                  : "btn btn-3d btn-full rounded-xs text-uppercase font-600 shadow-s border-red-dark bg-red-light"
              }`}
              onClick={() => setSelectedSeries(null)}
            >
              All
            </button>

            {series.map((ser) => (
              <button
                key={ser.series_id}
                style={{
                  display: "inline-flex",
                  margin: "5px 5px 5px",
                  padding: "5px 10px",
                  whiteSpace: "nowrap",
                }}
                className={`series-item ${
                  selectedSeries !== ser.series_id
                    ? "active btn btn-full rounded-0 text-uppercase font-400 border-red-dark color-red-dark bg-theme"
                    : "btn btn-3d btn-full rounded-xs text-uppercase font-600 shadow-s border-red-dark bg-red-light"
                }`}
                onClick={() => setSelectedSeries(ser.series_id)}
              >
                {ser.series_name}
              </button>
            ))}
          </div> */}
        </div>
        <br />
        <br />
        <br />
        <br />
        <div className="page-content">
          <div className="row mb-0" style={{ padding: "0px 10px" }}>
            {filteredData.map((product, index) => (
              <Link
                to={{
                  pathname: "/ProductDetails/" + product.product_id,
                  state: { stateParam: true },
                }}
                key={index}
                className="col-6 pe-0"
                style={{ padding: "0px", marginTop: "15px" }}
              >
                <div
                  className="card card-style"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                  }}
                >
                  <img
                    src={product.product_image}
                    style={{
                      height: "180px",
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    className="img-fluid"
                    alt={product.product_design_name}
                    // onClick={() => setSelectedImage(product.product_image)}
                  />
                  <div
                    className="content pb-0"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      margin: "0px 5px 5px 5px",
                    }}
                  >
                    {product.Product_discount_per && (
                      <div className="card-top m-2">
                        <span className="bg-blue-dark font-11 px-2 py-1 font-700 rounded-xs shadow-xxl">
                          {product.Product_discount_per} OFF
                        </span>
                      </div>
                    )}
                    <div className="p-2">
                      <h4
                        className="mb-0"
                        style={{ lineHeight: "15px", fontSize: "15px" }}
                      >
                        {product.product_design_name}
                      </h4>
                      <p
                        className="font-14 opacity-50"
                        style={{ lineHeight: "20px", paddingTop: "10px" }}
                      >
                        Code: {product.product_name}
                        <br />
                        Size: {product.size_name}
                        <br />
                        Series: {product.product_design_name}
                      </p>
                    </div>
                    <div>
                      <div className="divider mb-0"></div>
                      <h2
                        className="font-16 color-green-dark p-2"
                        style={{ marginBottom: "-13px" }}
                      >
                        {product.product_dealer_price !==
                          product.product_mrp && (
                          <span
                            style={{
                              fontWeight: "300",
                              textDecoration: "line-through",
                              color: "#6c6c6c",
                            }}
                          >
                            {product.product_mrp}
                          </span>
                        )}{" "}
                        {product.product_dealer_price}
                      </h2>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>

      {/* Modal for Zoomed Image */}
      {/* {selectedImage && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.95)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div
              className="modal-content"
              style={{ background: "transparent", border: "none" }}
            >
              <div className="modal-body text-center">
                <TransformWrapper>
                  <TransformComponent>
                    <img
                      src={selectedImage}
                      className="img-fluid"
                      style={{
                        objectFit: "contain",
                        marginLeft: "auto",
                        marginRight: "auto",
                        maxWidth: "100%",
                        cursor: "grab",
                      }}
                      alt="Zoomed"
                    />
                  </TransformComponent>
                </TransformWrapper>

                <button
                  className="btn btn-danger mt-3"
                  onClick={() => setSelectedImage(null)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
}

export default AllProducts;
